import { Component, ElementRef, ViewChild, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { IFieldModel } from '../../../../../../models/blueprint/blueprint-field.model';
import { IBluePrintModel } from '../../../../../../models/blueprint/blueprint.model';
import { BluePrintAPIService } from '../../../../../../services/api/blueprint.api.service';
import { Helper } from '../../../../../../services/helper.service';
import { FieldTableModel, IFieldTableModel } from '../../../../../../models/blueprint/blueprint-field-table.model';
import { PatchFieldPayload } from '../../../../../../models/field/patch-field-payload.model';
import { BlueprintDataHelper } from '../../../../../../services/helpers/blueprint-data.helper';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardHelper } from '../../../../../../services/dashboard.service';
import { UiStateStore } from '../../../../../../services/stores/ui-state.store';
import { BlueprintStore } from '../../../../../../services/stores/blueprint.store';
import { NgForm } from '@angular/forms';
import { UserService } from '../../../../../../services/user.service';
import { PermissionService } from '../../../../../../services/permission.service';

interface ITableRow {
  [key: string]: any; // This allows for additional dynamic properties
  catchindex?: string;
}

interface ITableConfig {
  position: number;
  header: string;
  name: string;
  type: string;
  options?: string[];
  localheader?: string;
}
@Component({
  selector: 'app-blueprint-field-table',
  templateUrl: './blueprint-field-table.component.html',
  styleUrls: ['./blueprint-field-table.component.css'],
  standalone: false,
})
export class BlueprintFieldTableComponent implements AfterViewInit, OnDestroy {
  @ViewChild('myForm') myForm!: NgForm;
  selectedBluePrintField: IFieldModel = {} as IFieldModel;
  selectedBluePrintFieldOldVal: IFieldModel = {} as IFieldModel;
  tableField: IFieldTableModel = {} as IFieldTableModel;
  selectedBluePrint: IBluePrintModel = {} as IBluePrintModel;
  oldName: string = '';
  formChanged: boolean = false;
  public tableData = [];
  public tableConfig: ITableConfig[] = [];
  public outputTableData: ITableRow[] = [];
  public subscribers: any = {};
  @ViewChild('inputName') inputNameElement!: ElementRef;

  constructor(
    private dashboardHelper: DashboardHelper,
    private bluePrintService: BluePrintAPIService,
    private bluePrintStore: BlueprintStore,
    private helperService: Helper,
    private uiStateStore: UiStateStore,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private bluePrintHelper: BlueprintDataHelper,
    private userService: UserService,
    private permissionService: PermissionService,
  ) {
    console.log('BlueprintFieldTableComponent');
  }

  public get isReadOnly(): boolean {
    if (this.permissionService.isSysAdmin) {
      return false;
    }
    const blueprintOrgId = this.selectedBluePrint?.organizationId?.toLowerCase();
    const userOrgId = this.userService.user?.organizationId?.toLowerCase();
    if (!blueprintOrgId || !userOrgId) {
      // Unknown org on either side - fail closed (read-only) rather than treat two empty/missing
      // org ids as a match.
      return true;
    }
    return blueprintOrgId !== userOrgId;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.subscribers.bp = this.bluePrintStore.$selectedBluePrint.subscribe((bp) => {
        if (bp) {
          this.selectedBluePrint = bp;
          if (!this.bluePrintStore.selectedBluePrintField) {
            this.subscribers.params = this.route.params.subscribe((params) => {
              if (params['id']) {
                if (this.selectedBluePrint) {
                  const blueprintField = this.selectedBluePrint.fields.find((field) => field.id === params['id']);
                  if (blueprintField) this.bluePrintStore.selectedBluePrintField = blueprintField;
                  this.dashboardHelper.setShowRightPanel(true);
                }
              }
            });
          }
        }
      });

      this.subscribers.rightPanelVisible = this.dashboardHelper.$showRightPanel.subscribe((panelVisibility) => {
        if (panelVisibility === false) {
          // If right side panel is closed without saving then reset to previous value
          if (this.selectedBluePrint && this.selectedBluePrintFieldOldVal) {
            const oldField = this.selectedBluePrint.fields.find((f) => f.id === this.selectedBluePrintFieldOldVal.id);
            if (oldField) this.selectedBluePrint.fields[this.selectedBluePrint.fields.indexOf(oldField)] = this.selectedBluePrintFieldOldVal;
            if (this.myForm && this.myForm.form.dirty && this.myForm.form.valid) {
              this.myForm.form.markAsPristine();
              this.cdr.detectChanges();
            }
          }
        }
      });

      this.subscribers.selectedItemChanged = this.dashboardHelper.selectedItem.subscribe((result) => {
        if (this.selectedBluePrintField && this.selectedBluePrintField.id !== result) {
          if ((this.myForm && this.myForm.form.dirty && this.myForm.form.valid) || this.formChanged) {
            this.myForm.form.markAsPristine();
            this.saveWork(false);
          }
        }
      });

      this.subscribers.bpfield = this.bluePrintStore.$selectedBluePrintField.subscribe((result) => {
        if (result) this.selectedBluePrintField = result;
        this.selectedBluePrintFieldOldVal = this.helperService.getDeepCopy(result);
        if (this.selectedBluePrintField) {
          if (this.selectedBluePrintField.value === null || this.selectedBluePrintField.value === '') {
            const newTableField: IFieldTableModel = new FieldTableModel(false, false, false, false);
            this.selectedBluePrintField.value = newTableField;
          }

          this.oldName = this.selectedBluePrintField.name;
          if (this.selectedBluePrintField.value.value === false) {
            this.selectedBluePrintField.value.value = [];
          }

          this.formChanged = false;

          if (this.selectedBluePrintField.value === '') {
            this.tableData = [];
            this.outputTableData = [];
            this.tableConfig = this.getTableConfig();
          } else {
            this.tableField = <IFieldTableModel>this.selectedBluePrintField.value;
            if (this.tableField) {
              this.tableData = this.tableField.value;
              this.outputTableData = this.tableField.value;
              this.tableConfig = this.getTableConfig();
            }
          }
          this.cdr.detectChanges();
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.cdr.detach();

    if (this.subscribers) {
      if (this.subscribers.bpfield) {
        this.subscribers.bpfield.unsubscribe();
      }
      if (this.subscribers.bp) {
        this.subscribers.bp.unsubscribe();
      }
      if (this.subscribers.params) {
        this.subscribers.params.unsubscribe();
      }
      if (this.subscribers.rightPanelVisible) {
        this.subscribers.rightPanelVisible.unsubscribe();
      }
      if (this.subscribers.selectedItemChanged) {
        this.subscribers.selectedItemChanged.unsubscribe();
      }
    }
  }

  public selectName() {
    const value = this.inputNameElement?.nativeElement?.value?.toLowerCase() ?? '';
    if (value.startsWith('table')) {
      this.inputNameElement?.nativeElement?.select();
    }
  }

  private addAutoNumberColumn(tableData: ITableRow[]): ITableRow[] {
    let isAutoNumberColumnExist = false;

    for (const row of tableData) {
      if (row['name'] === 'autonumber') {
        isAutoNumberColumnExist = true;
        break;
      }
    }

    if (!isAutoNumberColumnExist) {
      tableData.unshift({
        header: 'Row',
        name: 'autonumber',
        type: 'ReadonlyAutoNumber',
        position: '0',
      });
    }
    return tableData;
  }

  public saveWork(updateResponse: boolean = true) {
    if (this.isReadOnly) {
      return;
    }
    this.bluePrintHelper.validateName(this.oldName, 'field');

    const tableData = this.removeCatchIndexAndAddPositionToTableData();

    if (tableData.length > 0) {
      if (this.tableField.isAutoNumberColumn) {
        this.tableField.value = this.addAutoNumberColumn(tableData);
      } else {
        this.tableField.value = tableData;
      }
    } else {
      this.tableField.value = [];
    }

    const patchPayload: PatchFieldPayload = new PatchFieldPayload();
    patchPayload.bluePrintId = this.selectedBluePrint.id;
    patchPayload.field = this.selectedBluePrintField;
    patchPayload.updateResponse = updateResponse;
    this.selectedBluePrintFieldOldVal = this.selectedBluePrintField;
    // Dispatching the save clears dirty: the deselect auto-save (selectedItem subscription)
    // fires on a dirty form and would otherwise re-send this same patch, writing a second
    // identical 'blueprint modified' activity log entry (ZOO-10065). formChanged is a second
    // trigger for that same auto-save, so it has to be cleared here too.
    this.myForm?.form.markAsPristine();
    this.formChanged = false;
    this.uiStateStore.startBackendAction('Saving Table...');
    this.bluePrintService.patchField(patchPayload).subscribe({
      next: (result) => {
        this.uiStateStore.endBackendAction('Table saved!');
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.uiStateStore.endBackendAction('Error saving table');
        this.myForm?.form.markAsDirty(); // save failed - keep the edit re-savable
        this.formChanged = true;
        this.cdr.detectChanges();
      },
    });
    // this.uiHelper.closeRightPanel(this.router);
  }

  public onChange() {
    if (this.isReadOnly) {
      return;
    }
    if (this.selectedBluePrintField.name === '') {
      return;
    }
    this.dashboardHelper.setModifiedPropertyItem({
      id: this.selectedBluePrintField.id,
      name: this.selectedBluePrintField.name,
    });
  }

  public onNameBlur() {
    if (this.isReadOnly) {
      return;
    }
    if (this.selectedBluePrintField.name === '') {
      this.selectedBluePrintField.name = this.oldName; // revert to old name
      this.dashboardHelper.setModifiedPropertyItem({
        // update the diagram
        id: this.selectedBluePrintField.id,
        name: this.selectedBluePrintField.name,
      });
    } else {
      this.bluePrintHelper.validateName(this.oldName, 'field');
      this.oldName = this.selectedBluePrintField.name;
    }
  }

  onGetTableDataOutput(data: any) {
    if (this.isReadOnly) {
      return;
    }
    this.formChanged = true;
    this.outputTableData = data;
  }

  private getDeepCopy(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }

  private removeCatchIndexAndAddPositionToTableData() {
    const tableDataWithPosition: ITableRow[] = [];
    let position = 1;

    if (this.outputTableData) {
      this.outputTableData.forEach((row) => {
        row['position'] = position;
        ++position;
        const copy = this.getDeepCopy(row);
        delete copy['catchindex'];
        tableDataWithPosition.push(copy);
      });
    }
    return tableDataWithPosition;
  }

  private getTableConfig(): ITableConfig[] {
    return [
      { position: 1, header: 'Column Name', name: 'header', type: 'text' },

      {
        position: 2,
        header: 'Data Type',
        name: 'type',
        type: 'dropdown',
        options: ['Text', 'DropdownSingle', 'Checkbox', 'DropdownMultiple', 'Number', 'Attachment'],
        localheader: 'header',
      },
      // will add more options later
    ];
  }
}
